import { api } from '@/lib/axios';

export interface GenerateEmailDto {
  prompt: string;
  image?: string;
  context?: string;
}

export interface GenerateEmailResponse {
  content: string;
}

export interface TestConnectionResponse {
  success: boolean;
  message: string;
  model?: string;
}

export interface GenerateProductDescriptionDto {
  name: string;
  category: string;
  currentDescription?: string;
  brand?: string;
  tags?: string;
}

export interface GenerateProductDescriptionResponse {
  description: string;
}

export interface GenerateVenueDescriptionDto {
  name: string;
  area?: number;
  capacity?: number;
  currentDescription?: string;
  images?: string[];
}

export interface GenerateVenueDescriptionResponse {
  description: string;
}

export interface GenerateFlowDto {
  prompt: string;
  currentFlow?: {
    nodes: any[];
    edges: any[];
  };
  flowDescription?: string;
}

export interface GenerateFlowResponse {
  nodes: any[];
  edges: any[];
}

export const aiService = {
  async testConnection(): Promise<TestConnectionResponse> {
    const response = await api.get<TestConnectionResponse>('/ai/test-connection');
    return response.data;
  },

  async generateEmailContent(data: GenerateEmailDto): Promise<GenerateEmailResponse> {
    const response = await api.post<GenerateEmailResponse>('/ai/generate-email', data);
    return response.data;
  },

  async generateProductDescription(data: GenerateProductDescriptionDto): Promise<GenerateProductDescriptionResponse> {
    const response = await api.post<GenerateProductDescriptionResponse>('/ai/generate-product-description', data);
    return response.data;
  },

  async generateVenueDescription(data: GenerateVenueDescriptionDto): Promise<GenerateVenueDescriptionResponse> {
    const response = await api.post<GenerateVenueDescriptionResponse>('/ai/generate-venue-description', data);
    return response.data;
  },

  async generateFlow(data: GenerateFlowDto): Promise<GenerateFlowResponse> {
    const response = await api.post<GenerateFlowResponse>('/ai/generate-flow', data);
    return response.data;
  },
};
